import React, { FunctionComponent } from 'react'
import { SVGProps } from 'interfaces'

const SVG: FunctionComponent<SVGProps> = ({ className }) => (
    <svg width='100%' className={className} viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M13 9H14.5C15.3284 9 16 9.67157 16 10.5C16 11.3284 15.3284 12 14.5 12H1.5C0.671573 12 0 11.3284 0 10.5C0 9.67157 0.671573 9 1.5 9H3L3.55827 3.97553C3.80975 1.71226 5.72279 0 8 0C10.2772 0 12.1903 1.71226 12.4417 3.97553L13 9Z'
            fill='#52BD95'
        />
        <path
            opacity='0.3'
            d='M10 15C10 13.8954 9.10457 13 8 13C6.89543 13 6 13.8954 6 15C6 16.1046 6.89543 17 8 17C9.10457 17 10 16.1046 10 15Z'
            fill='#52BD95'
        />
    </svg>
)

export default SVG
